const roles = {
  afterPrinter: 'ROLE_AFTER_PRINTER',
  printer: 'ROLE_PRINTER',
  designer: 'ROLE_DESIGNER',
  manager: 'ROLE_MANAGER',
  director: 'ROLE_ADMIN',
  admin: 'ROLE_SUPER_ADMIN',
  master: 'ROLE_MASTER',
  accountant: 'ROLE_ACCOUNTANT',
  adAgent: 'ROLE_AD_AGENT'
}

export default roles
